
import { computed, defineComponent, PropType } from 'vue';
import { CardImage, CardInfo } from '@/components/atoms';
import { Pokemon } from '@/types';

export default defineComponent({
  name: 'Card',
  components: {
    CardImage,
    CardInfo,
  },
  props: {
    pokemons: {
      type: Object as PropType<Pokemon[]>,
      required: true,
    },
  },
  setup(props) {
    // eslint-disable-next-line arrow-body-style
    const orderedPokemons = computed(() => {
      // eslint-disable-next-line vue/no-mutating-props
      return props.pokemons.sort((a:Pokemon, b:Pokemon) => (a.name > b.name ? 1 : -1));
    });

    return { orderedPokemons };
  },
});
